export default __webpack_public_path__ + "static/Graphik-LightItalic-Web-0292ab63754fc93ff2afdf99069cfdd7.eot";